<div class="privacy-page">

  <!-- Hero -->
  <div class="privacy-hero">
    <div class="privacy-hero__bg"></div>
    <div class="privacy-hero__content">
      <a routerLink="/" class="privacy-hero__back">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <path d="M19 12H5M5 12l7-7M5 12l7 7"/>
        </svg>
        Retour à l'accueil
      </a>
      <div class="privacy-hero__badge">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
        </svg>
        Protection des données
      </div>
      <h1 class="privacy-hero__title">Politique de confidentialité</h1>
      <p class="privacy-hero__subtitle">Nous nous engageons à protéger vos données personnelles conformément au RGPD et à la loi belge du 30 juillet 2018.</p>
      <p class="privacy-hero__date">Dernière mise à jour : {{ lastUpdate }}</p>
    </div>
  </div>

  <div class="privacy-layout">

    <!-- Sidebar -->
    <aside class="privacy-sidebar">
      <div class="privacy-sidebar__inner">
        <p class="privacy-sidebar__label">Sommaire</p>
        <nav class="privacy-sidebar__nav">
          <button
            *ngFor="let section of sections; let i = index"
            class="privacy-sidebar__item"
            (click)="scrollTo(section.id)">
            <span class="privacy-sidebar__num">{{ (i + 1).toString().padStart(2, '0') }}</span>
            <span>{{ section.title }}</span>
          </button>
        </nav>
      </div>
    </aside>

    <!-- Main content -->
    <main class="privacy-content">

      <!-- Sections -->
      <ng-container *ngFor="let section of sections; let i = index">

        <!-- Section standard -->
        <section
          *ngIf="section.id !== 'collecte' && section.id !== 'droits' && section.id !== 'cookies'"
          [id]="section.id"
          class="privacy-section">
          <div class="privacy-section__header">
            <div class="privacy-section__icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path [attr.d]="section.icon"/>
              </svg>
            </div>
            <div>
              <span class="privacy-section__num">{{ (i + 1).toString().padStart(2, '0') }}</span>
              <h2 class="privacy-section__title">{{ section.title }}</h2>
            </div>
          </div>
          <div class="privacy-section__body">
            <p *ngFor="let p of section.content" class="privacy-section__p" [innerHTML]="p"></p>
          </div>
        </section>

        <!-- Section collecte avec tableau -->
        <section *ngIf="section.id === 'collecte'" [id]="section.id" class="privacy-section">
          <div class="privacy-section__header">
            <div class="privacy-section__icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path [attr.d]="section.icon"/>
              </svg>
            </div>
            <div>
              <span class="privacy-section__num">{{ (i + 1).toString().padStart(2, '0') }}</span>
              <h2 class="privacy-section__title">{{ section.title }}</h2>
            </div>
          </div>
          <div class="privacy-section__body">
            <p *ngFor="let p of section.content" class="privacy-section__p" [innerHTML]="p"></p>

            <!-- Data table -->
            <div class="privacy-table-wrap">
              <table class="privacy-table">
                <thead>
                  <tr>
                    <th *ngFor="let h of dataTypes.headers">{{ h }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of dataTypes.rows">
                    <td *ngFor="let cell of row; let ci = index" [class.privacy-table__first]="ci === 0">{{ cell }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>

        <!-- Section droits avec cards -->
        <section *ngIf="section.id === 'droits'" [id]="section.id" class="privacy-section">
          <div class="privacy-section__header">
            <div class="privacy-section__icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path [attr.d]="section.icon"/>
              </svg>
            </div>
            <div>
              <span class="privacy-section__num">{{ (i + 1).toString().padStart(2, '0') }}</span>
              <h2 class="privacy-section__title">{{ section.title }}</h2>
            </div>
          </div>
          <div class="privacy-section__body">
            <p class="privacy-section__p" [innerHTML]="section.content[0]"></p>

            <!-- Rights grid -->
            <div class="privacy-rights">
              <div *ngFor="let right of rights" class="privacy-rights__card">
                <span class="privacy-rights__icon">{{ right.icon }}</span>
                <strong class="privacy-rights__title">{{ right.title }}</strong>
                <p class="privacy-rights__desc">{{ right.desc }}</p>
              </div>
            </div>

            <p *ngFor="let p of section.content.slice(1)" class="privacy-section__p" [innerHTML]="p"></p>
          </div>
        </section>

        <!-- Section cookies avec cards -->
        <section *ngIf="section.id === 'cookies'" [id]="section.id" class="privacy-section">
          <div class="privacy-section__header">
            <div class="privacy-section__icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path [attr.d]="section.icon"/>
              </svg>
            </div>
            <div>
              <span class="privacy-section__num">{{ (i + 1).toString().padStart(2, '0') }}</span>
              <h2 class="privacy-section__title">{{ section.title }}</h2>
            </div>
          </div>
          <div class="privacy-section__body">
            <p *ngFor="let p of section.content" class="privacy-section__p" [innerHTML]="p"></p>

            <!-- Cookie types -->
            <div class="privacy-cookies">
              <div *ngFor="let cookie of cookieTypes" class="privacy-cookies__card">
                <div class="privacy-cookies__header">
                  <strong class="privacy-cookies__name">{{ cookie.name }}</strong>
                  <span class="privacy-cookies__badge" [class.privacy-cookies__badge--required]="cookie.required">
                    {{ cookie.required ? 'Obligatoire' : 'Optionnel' }}
                  </span>
                </div>
                <p class="privacy-cookies__desc">{{ cookie.description }}</p>
                <p class="privacy-cookies__examples"><strong>Exemples :</strong> {{ cookie.examples }}</p>
              </div>
            </div>
          </div>
        </section>

      </ng-container>

      <!-- APD contact card -->
      <div class="privacy-apd-card">
        <div class="privacy-apd-card__left">
          <div class="privacy-apd-card__shield">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            </svg>
          </div>
          <div>
            <strong>Autorité de Protection des Données (APD)</strong>
            <p>L'autorité de contrôle belge compétente pour toute réclamation relative à vos données.</p>
          </div>
        </div>
        <a href="https://www.autoriteprotectiondonnees.be" target="_blank" rel="noopener" class="privacy-apd-card__btn">
          Visiter l'APD
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14L21 3"/>
          </svg>
        </a>
      </div>

    </main>
  </div>
</div>